import { Badge, Col, Divider, Flex, Form, Row, Spin, Modal, Button } from "antd";
import React, { useEffect, useState } from "react";
import CustomTypography from "../../components/common/CustomTypography";
import { DeleteOutlined, LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import CustomButton from "../../components/common/CustomButton";
import dayjs from "dayjs";
import BankAccountDetailFirstForm from "./Forms/BankAccountDetailFirstForm";
import BankAccountDetailSecondForm from "./Forms/BankAccountDetailSecondForm";
import UploadBankStatementForm from "./Forms/UploadBankStatementForm";
import { useDispatch, useSelector } from "react-redux";
import {
  setNavBredcrumb,
  setNavNewReportBtn,
} from "../../store/reducers/slices/topnav.slice";
import { useLocation, useNavigate } from "react-router-dom";
import {
  createReport,
  getAnalysisProgress,
  getBankListOptions,
  getReportDetailByReferrenceId,
  updateReport,
} from "../../api/reportDetails";
import {
  setBankOptions,
  setCreateReportData,
  setCreateReportError,
  setCreateReportLoading,
  setReportAnalysisProgress,
  setReportAnalysisProgressError,
  setReportAnalysisProgressLoading,
  setReportAnalysisStatus,
} from "../../store/reducers/slices/createReport.slice";
import {
  setEditUploadedFiles,
  setUploadedAccountDetails,
} from "../../store/reducers/slices/updateReport.slice";
import styles from "./newform.module.scss";
import ReportStatusModal from "../../components/ReportStatusModal";
import { showNotification } from "../../store/reducers/slices/notification.slice";
import { Link, useParams } from "react-router-dom";
import { setHomeDetails } from "../../store/reducers/slices/home.slice";
import { getRecentAnalyzedReports } from "../../api/homepage";
import { setExtractedData } from "../../store/reducers/slices/extractedData.slice";

const reportDto = {
  report: {
    reportId: "PR5940366775748686",
    reportName: "Multiple File Report",
    reportStatus: "IN PROGRESS",
    reportStatusDescription: "IN PROGRESS",
    reportCamStatus: "",
    reportType: "1",
    lastUpdatedOn: "2024-10-10 18:18:30",
    createdOn: "2024-10-10 18:18:30",
  },
  reportAccounts: [
    {
      account: {
        accountId: "2",
        accountName: "MAHESHWARI TRADERS",
        accountNumber: "123456763542",
        ifscCode: "",
        accountType: "2",
        accountTypeName: "Current Account",
        bankId: "1",
        bankName: "Axis Bank",
        status: "INITIALISING",
        statusDescription: "INITIALISING",
        camStatus: "",
        startDate: "2020-01-02",
        endDate: "2020-09-02",
        phoneNumber: "",
        jointHolderName: "",
        accountHolderName: "MAHESHWARI TRADERS",
        micrCode: "",
        branchAddress: "",
        branchName: "",
        panNumber: "",
        email: "",
        customerAddress:
          "GANRAJ HEIGHTS SHOP NO 7 PUNE MAHARASHTRA  INDIA PIN  401012",
        accountOpeningDate: "",
        verifiedAccount: "2",
        analysisStartDate: "",
        analysisEndDate: "",
        analysisPeriod: "",
        transactionStartDate: "",
        transactionEndDate: "",
        currency: "INR",
        currencyFormat: "##,##,###.##",
        accountStatus: "",
        accountReferenceNumber: "PARN2",
        lastModifiedDate: "2024-10-10 12:48:30",
      },
      fileDetails: {
        accountId: 2,
        accountReferenceNumber: "PARN2",
        success: [
          {
            fileId: 4,
            status: "INITIALISING",
            originalName: "Axis bank-123456763542.pdf",
            documentType: "BANK_STATEMENT",
            password: "",
            creatorName: "",
            producerName: "",
            statusDescription: "",
          },
        ],
        failed: [],
        gstId: null,
        gstReferenceNumber: null,
        cicId: null,
        cicReferenceNumber: null,
        fileName: null,
        password: null,
      },
    },
    {
      account: {
        accountId: "3",
        accountName: "MAHESHWARI TRADERS",
        accountNumber: "123456763542",
        ifscCode: "",
        accountType: "2",
        accountTypeName: "Current Account",
        bankId: "1",
        bankName: "Axis Bank",
        status: "INITIALISING",
        statusDescription: "INITIALISING",
        camStatus: "",
        startDate: "2020-01-02",
        endDate: "2020-09-02",
        phoneNumber: "",
        jointHolderName: "",
        accountHolderName: "MAHESHWARI TRADERS",
        micrCode: "",
        branchAddress: "",
        branchName: "",
        panNumber: "",
        email: "",
        customerAddress:
          "GANRAJ HEIGHTS SHOP NO 7 PUNE MAHARASHTRA  INDIA PIN  401012",
        accountOpeningDate: "",
        verifiedAccount: "2",
        analysisStartDate: "",
        analysisEndDate: "",
        analysisPeriod: "",
        transactionStartDate: "",
        transactionEndDate: "",
        currency: "INR",
        currencyFormat: "##,##,###.##",
        accountStatus: "",
        accountReferenceNumber: "PARN3",
        lastModifiedDate: "2024-10-10 12:48:30",
      },
      fileDetails: {
        accountId: 3,
        accountReferenceNumber: "PARN3",
        success: [
          {
            fileId: 5,
            status: "INITIALISING",
            originalName: "Axis bank-123456763542.pdf",
            documentType: "BANK_STATEMENT",
            password: "",
            creatorName: "",
            producerName: "",
            statusDescription: "",
          },
        ],
        failed: [],
        gstId: null,
        gstReferenceNumber: null,
        cicId: null,
        cicReferenceNumber: null,
        fileName: null,
        password: null,
      },
    },
  ],
  reportGst: [],
  reportCreditBureaus: [],
};

const NewReport = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const params = useParams();


  const {
    bankOptions,
    reportAnalysisStatus,
    createReportData,
    createReportLoading,
  } = useSelector(({ createReport }) => createReport);
  const { uploadedAccountDetails } = useSelector(
    ({ updateReport }) => updateReport
  );
  const { extractedData, extractedDataLoading } = useSelector(
    ({ extractedData }) => extractedData
  );
  const [uploadedFiles, setUploadedFiles] = useState([[]]);
  const [form] = Form.useForm();
  const [reportModalOpen, setReportModalOpen] = useState(false);
  const [startAnanlysis, setStartAnalysis] = useState(false);
  const [previousData, setPreviousData] = useState([]);
  const [editData, setEditData] = useState({});
  const navigate = useNavigate();
  const [changedFields, setChangedFields] = useState({});
  const isEdit = location.pathname.includes("edit");

  const handleFilesChange = (index, files) => {
    console.log("Files", files);
    const newUploadedFiles = [...uploadedFiles];
    newUploadedFiles[index] = files; // Update the files for the specific form
    setUploadedFiles(newUploadedFiles);
  };
  const [isModalOpen, setIsModalOpen] = useState(false);


  const showModal = () => {
    setIsModalOpen(true);
  };

  useEffect(() => {

    const fetchBankListOptions = async () => {
      try {
        const response = await getBankListOptions();
        // console.log("BANKLISTOPTIONS",response);
        let structureBankOptions = response.map((bankItem, index) => {
          return {
            id: bankItem.id,
            value: bankItem.id,
            label: bankItem.name,
          };
        });
        dispatch(setBankOptions(structureBankOptions));
      } catch (error) {
        console.log("ERROR", error);
        dispatch(showNotification({ message: error.message, type: "error" }));
      }
    };

    if (!bankOptions.length) {
      fetchBankListOptions();
    }
  }, [dispatch, location.pathname]);

  const getModifiedData = (previousData, newData) => {
    console.log("NEWDATA", newData);
    console.log("PREVDATA", previousData);

    const modifiedData = [];

    newData.forEach((newItem, index) => {
      const prevItem = previousData[index];
      const modifiedFields = {};

      // Compare each field in newItem with prevItem
      if (prevItem) {
        Object.keys(newItem).forEach((key) => {
          if (newItem[key] !== prevItem[key]) {
            modifiedFields[key] = newItem[key];
          }
        });

        console.log("MODI FIED FIELDS", modifiedFields);

        // If there are modified fields, add this to modifiedData
        if (Object.keys(modifiedFields).length > 0) {
          const modifiedObject = {
            accountId: newItem.accountId,
            ...modifiedFields,
          };
          const fileDetails = [
            {
              fileName: newItem.upload || "", // Set fileName from upload key
              password: newItem.password || "", // Set password from ifscCode key
            },
          ];
          modifiedData.push({
            account: modifiedObject,
            fileDetails: fileDetails,
            password: newItem.password || "",
          });
        }
      } else {
        const modifiedObject = {
          ...newItem,
        };
        const fileDetails = [
          {
            fileName: newItem.upload || "", // Set fileName from upload key
            password: newItem.password || "", // Set password from ifscCode key
          },
        ];
        modifiedData.push({
          account: modifiedObject,
          fileDetails: fileDetails,
          password: newItem.password || "",
        });
      }
    });

    return modifiedData;
  };

  console.log("uploadedAccountDetails", uploadedAccountDetails);

  const handleAddBankAccount = async (values) => {
    const isEdit = location.pathname.includes("edit");

    console.log("Fields to submit:", changedFields);

    console.log("DANITEST", values);

    // const modifiedAccounts = isEdit && getModifiedData(previousData, values?.bankAccounts);
    // console.log("Modified Accounts:", modifiedAccounts);
    // const existingAccEdit = modifiedAccounts.map((item) => {
    //     // console.log("Items existingAccEdit", item);

    //   return item
    // })

    // console.log("existingAccEdit", existingAccEdit.length);

    let allUploadedFiles = [];
    values.bankAccounts.forEach((formItem, index) => {
      console.log("PREPARING FILE NAME::..>", formItem);

      // Check if formItem.upload is an array (multiple files) or a single object (single file)
      let obj = {
        name: formItem.upload,
        password: formItem.password || "",
      };
      let indexFile = [obj];
      const _uploadedFiles = isEdit ? indexFile : extractedData[index]?.uploadedFiles || [];

      // Add the array of uploaded files (or empty array) to the main array
      allUploadedFiles.push(_uploadedFiles);
    });

    console.log("allUploadedFiles", allUploadedFiles);

    const accountTypes = [
      { name: "Savings Account", title: "Savings", id: 1 },
      { name: "Current Account", title: "Current", id: 2 },
      // {
      //     name: 'OD or CC Account',
      //     title: 'OD or CC Account',
      //     id: 3
      // }
    ];

    // TESTING
    console.log("DANI", values);
    let bankDetails = [];

    if (isEdit) {
      let newData = values.bankAccounts.reduce((bankDetails, bank, index) => {
        let fileNames = allUploadedFiles[index].map((file) => file.name);
        console.log("fileNames", fileNames);

        for (let i = 0; i < fileNames.length; i++) {
          // fileNames.map((f, index) => {
          fileNames[i] = `${fileNames[i]}`; // BSA0_file1
          // });
        }
        console.log("FILENAMES", fileNames);
        console.log("BANK", bank);
        const currentFieldValues = form.getFieldsValue();
        console.log("currentFieldValues", currentFieldValues, index);

        // if(isEdit && bank.isNew === false){
        //     existingAccEdit.forEach((item) => bankDetails.push(item))
        // }

        console.log("accountType", bank.accountType, "TEST =>", accountTypes);

        const type = accountTypes.find(
          (type) => bank.accountType.toLowerCase() === type.name.toLowerCase()
        ).id;
        const data = {
          bankId: Number.isInteger(bank.bankName)
            ? bank.bankName
            : +bank.bankId,
          accountId: bank.accountId,
          accountType: type,
          accountNumber: bank.accountNumber
            ? bank.accountNumber.replace(/[\\^$*+?&.;%@',"<>()|[\]{}]/g, "")
            : bank.accountNumber,
          ifscCode: bank.ifscCode,
          accountStatus: bank?.accountStatus?.substring(0, 99),
          analysisStartDate:
            bank.analysisFrom && dayjs(bank.analysisFrom).format("YYYY-MM-DD"),
          analysisEndDate:
            bank.analysisTo && dayjs(bank.analysisTo).format("YYYY-MM-DD"),
          startDate:
            bank.statementStartsFrom &&
            dayjs(bank.statementStartsFrom).format("YYYY-MM-DD"),
          endDate:
            bank.statementEndsFrom &&
            dayjs(bank.statementEndsFrom).format("YYYY-MM-DD"),
          micrCode: bank.micrCode,
          branchName: bank.branchName
            ? bank.branchName.replace(/[\\^$*+?;%@'"<>|[\]{}]/g, "")
            : bank.branchName,
          branchAddress: bank.branchAddress
            ? bank.branchAddress.replace(/[\\^$*+?;%@'"<>|[\]{}]/g, "")
            : bank.branchAddress,
          accountHolderName: bank.accountHolderName,
          // ? bank.accountHolderName.replace(
          //     /[\\^$*+?;%@'"<>&-|[\]{}]/g,
          //     ''
          // )
          // : bank.accountHolderName
          jointHolderName: bank.jointHolderName
            ? bank.jointHolderName.replace(/[\\^$*+?;%@'"<>|[\]{}]/g, "")
            : bank.jointHolderName,
          email: bank.email,
          phoneNumber: bank.phone,
          panNumber: bank.pan,
          customerAddress: bank.address
            ? bank.address.replace(/[\\^$*+?;%@'"<>|[\]{}]/g, "")
            : bank.address,
          accountOpeningDate:
            bank.accountOpeningDate &&
            dayjs(bank.accountOpeningDate).format("YYYY-MM-DD"),
          // TODO: Need to verify keys
          transactionStartDate:
            bank.statementStartsFrom &&
            dayjs(bank.statementStartsFrom).format("YYYY-MM-DD" || null),
          transactionEndDate:
            bank.statementEndsFrom &&
            dayjs(bank.statementEndsFrom).format("YYYY-MM-DD" || null),
          analysisPeriod: (bank.analysisPeriod && bank.analysisPeriod) || null,
          fiTypes: ["DEPOSIT"],
          // isNew: bank?.isNew,
          // password: '',
          fileNames: [`${bank.upload}`],
          fileDetails: allUploadedFiles[index].map((file) => ({
            fileName: `${file.name}`,
            password: file.password || "",
          })),
        };
        // if (type === 3 || type === 4) {
        //     console.log("SANCTION LIMIT:",data);

        //     data.sanctionLimits = bank.sanctionLimit.reduce(
        //         (sanctionLimits, limit) => {
        //             const object = {
        //                 sanctionAmount: limit.amount,
        //                 startDate:
        //                     limit.startDate &&
        //                     dayjs(limit.startDate).format('YYYY-MM-DD'),
        //                 endDate:
        //                     limit.endDate && dayjs(limit.endDate).format('YYYY-MM-DD')
        //             };
        //             sanctionLimits.push(object);
        //             return sanctionLimits;
        //         },
        //         []
        //     );
        // }
        console.log("BANKDETAILS", bankDetails);

        // console.log("BANK DETAILS 2", bankDetails);
        // if(isEdit && bank.isNew === false){
        //     console.log("UNDER IF INDEX OF REDUCE", index);
        //     let test = existingAccEdit[index]
        //     bankDetails.push(test)
        // }
        bankDetails.push(data);
        console.log("PUSH", data);
        return bankDetails;
      }, []);

      let previousDataa = previousData.reduce((bankDetails, bank, index) => {
        let fileNames = allUploadedFiles[index].map((file) => file.name);
        console.log("fileNames", fileNames);

        for (let i = 0; i < fileNames.length; i++) {
          // fileNames.map((f, index) => {
          fileNames[i] = `${fileNames[i]}`; // BSA0_file1
          // });
        }
        console.log("FILENAMES", fileNames);
        console.log("BANK", bank);
        const currentFieldValues = form.getFieldsValue();
        console.log("currentFieldValues", currentFieldValues, index);

        // if(isEdit && bank.isNew === false){
        //     existingAccEdit.forEach((item) => bankDetails.push(item))
        // }

        console.log("accountType", bank.accountType, "TEST =>", accountTypes);

        const type = accountTypes.find(
          (type) => bank.accountType.toLowerCase() === type.name.toLowerCase()
        ).id;
        const data = {
          bankId: Number.isInteger(bank.bankName)
            ? bank.bankName
            : +bank.bankId,
          accountId: bank.accountId,
          accountType: type,
          accountNumber: bank.accountNumber
            ? bank.accountNumber.replace(/[\\^$*+?&.;%@',"<>()|[\]{}]/g, "")
            : bank.accountNumber,
          ifscCode: bank.ifscCode,
          accountStatus: bank?.accountStatus?.substring(0, 99),
          analysisStartDate:
            bank.analysisFrom && dayjs(bank.analysisFrom).format("YYYY-MM-DD"),
          analysisEndDate:
            bank.analysisTo && dayjs(bank.analysisTo).format("YYYY-MM-DD"),
          startDate:
            bank.statementStartsFrom &&
            dayjs(bank.statementStartsFrom).format("YYYY-MM-DD"),
          endDate:
            bank.statementEndsFrom &&
            dayjs(bank.statementEndsFrom).format("YYYY-MM-DD"),
          micrCode: bank.micrCode,
          branchName: bank.branchName
            ? bank.branchName.replace(/[\\^$*+?;%@'"<>|[\]{}]/g, "")
            : bank.branchName,
          branchAddress: bank.branchAddress
            ? bank.branchAddress.replace(/[\\^$*+?;%@'"<>|[\]{}]/g, "")
            : bank.branchAddress,
          accountHolderName: bank.accountHolderName,
          // ? bank.accountHolderName.replace(
          //     /[\\^$*+?;%@'"<>&-|[\]{}]/g,
          //     ''
          // )
          // : bank.accountHolderName
          jointHolderName: bank.jointHolderName
            ? bank.jointHolderName.replace(/[\\^$*+?;%@'"<>&-|[\]{}]/g, "")
            : bank.jointHolderName,
          email: bank.email,
          phoneNumber: bank.phone,
          panNumber: bank.pan,
          customerAddress: bank.address
            ? bank.address.replace(/[\\^$*+?;%@'"<>|[\]{}]/g, "")
            : bank.address,
          accountOpeningDate:
            bank.accountOpeningDate &&
            dayjs(bank.accountOpeningDate).format("YYYY-MM-DD"),
          // TODO: Need to verify keys
          transactionStartDate:
            bank.statementStartsFrom &&
            dayjs(bank.statementStartsFrom).format("YYYY-MM-DD" || null),
          transactionEndDate:
            bank.statementEndsFrom &&
            dayjs(bank.statementEndsFrom).format("YYYY-MM-DD" || null),
          analysisPeriod: (bank.analysisPeriod && bank.analysisPeriod) || null,
          fiTypes: ["DEPOSIT"],
          // isNew: bank?.isNew,
          // password: '',
          fileNames: fileNames,
          fileDetails: allUploadedFiles[index].map((file) => ({
            fileName: `${file.name}`,
            password: file.password || "",
          })),
        };
        // if (type === 3 || type === 4) {
        //     console.log("SANCTION LIMIT:",data);

        //     data.sanctionLimits = bank.sanctionLimit.reduce(
        //         (sanctionLimits, limit) => {
        //             const object = {
        //                 sanctionAmount: limit.amount,
        //                 startDate:
        //                     limit.startDate &&
        //                     dayjs(limit.startDate).format('YYYY-MM-DD'),
        //                 endDate:
        //                     limit.endDate && dayjs(limit.endDate).format('YYYY-MM-DD')
        //             };
        //             sanctionLimits.push(object);
        //             return sanctionLimits;
        //         },
        //         []
        //     );
        // }
        console.log("BANKDETAILS", bankDetails);

        // console.log("BANK DETAILS 2", bankDetails);
        // if(isEdit && bank.isNew === false){
        //     console.log("UNDER IF INDEX OF REDUCE", index);
        //     let test = existingAccEdit[index]
        //     bankDetails.push(test)
        // }
        bankDetails.push(data);
        console.log("PUSH", data);
        return bankDetails;
      }, []);
      console.log("ON VALUE CHANGE LOG", values);
      console.log("ON VALUE CHANGE LOG 1", previousDataa);
      console.log("NEWDATA", newData);
      console.log("PREVDATA", previousData);

      const modifiedData = [];

      function compareValues(newValue, prevValue) {
        if (Array.isArray(newValue) && Array.isArray(prevValue)) {
          // Compare arrays
          if (
            newValue.length !== prevValue.length ||
            !newValue.every(
              (val, idx) =>
                JSON.stringify(val) === JSON.stringify(prevValue[idx])
            )
          ) {
            return newValue; // Return the new array if there's a difference
          }
        } else if (
          typeof newValue === "object" &&
          typeof prevValue === "object"
        ) {
          // Compare objects recursively
          const diff = {};
          Object.keys(newValue).forEach((key) => {
            if (newValue[key] !== prevValue[key]) {
              const result = compareValues(newValue[key], prevValue[key]);
              if (result !== undefined) {
                diff[key] = result;
              }
            }
          });

          if (Object.keys(diff).length > 0) {
            return diff;
          }
        } else if (newValue !== prevValue) {
          // Return the new value if primitive and different
          return newValue;
        }
        return undefined; // No differences
      }

      newData.forEach((newItem, index) => {
        const prevItem = previousDataa[index];
        const modifiedFields = {};

        if (prevItem) {
          // Compare fields
          Object.keys(newItem).forEach((key) => {
            if (newItem[key] !== prevItem[key]) {
              const result = compareValues(newItem[key], prevItem[key]);
              if (result !== undefined) {
                modifiedFields[key] = result;
              }
            }
          });

          // Add modified fields to the array
          console.log("MODIFIED FIEDS>>>", modifiedFields);

          if (Object.keys(modifiedFields).length > 0) {
            console.log("NEW ITEMS UNDER IF", newItem);

            bankDetails.push({
              account: { accountId: newItem.accountId, ...modifiedFields },
              fileDetails: newItem.fileDetails || [],
              password: newItem.password || "",
            });
          }
        } else {
          // New item handling
          let { accountId, fileNames, fileDetails, ...restNewItem } = newItem;
          bankDetails.push({
            account: restNewItem,
            fileDetails: newItem.fileDetails || [],
            fileNames,
            // password: newItem.password || ""
          });
        }
      });

      console.log("EDIT PAYLOAD PREPARE:", bankDetails);

      // return values;
    } else {
      bankDetails = values.bankAccounts.reduce((bankDetails, bank, index) => {
        let fileNames = allUploadedFiles[index].map((file) => file?.path?.name);
        console.log("fileNames", fileNames);

        for (let i = 0; i < fileNames.length; i++) {
          // fileNames.map((f, index) => {
          fileNames[i] = `${fileNames[i]}`; // BSA0_file1
          // });
        }
        console.log("FILENAMES", fileNames);
        console.log("BANK", bank);
        const currentFieldValues = form.getFieldsValue();
        console.log("currentFieldValues", currentFieldValues, index);

        // if(isEdit && bank.isNew === false){
        //     existingAccEdit.forEach((item) => bankDetails.push(item))
        // }

        console.log("accountType", bank.accountType, "TEST =>", accountTypes);

        const type = accountTypes.find(
          (type) => bank.accountType.toLowerCase() === type.name.toLowerCase()
        ).id;
        const data = {
          account: {
            bankId: Number.isInteger(bank.bankName)
              ? bank.bankName
              : +bank.bankId,
            accountType: type,
            accountNumber: bank.accountNumber
              ? bank.accountNumber.replace(/[\\^$*+?&.;%@',"<>()|[\]{}]/g, "")
              : bank.accountNumber,
            ifscCode: bank.ifscCode,
            accountStatus: bank?.accountStatus?.substring(0, 99),
            analysisStartDate:
              bank.analysisFrom &&
              dayjs(bank.analysisFrom).format("YYYY-MM-DD"),
            analysisEndDate:
              bank.analysisTo && dayjs(bank.analysisTo).format("YYYY-MM-DD"),
            startDate:
              bank.statementStartsFrom &&
              dayjs(bank.statementStartsFrom).format("YYYY-MM-DD"),
            endDate:
              bank.statementEndsFrom &&
              dayjs(bank.statementEndsFrom).format("YYYY-MM-DD"),
            micrCode: bank.micrCode,
            branchName: bank.branchName
              ? bank.branchName.replace(/[\\^$*+?;%@'"<>|[\]{}]/g, "")
              : bank.branchName,
            branchAddress: bank.branchAddress
              ? bank.branchAddress.replace(/[\\^$*+?;%@'"<>|[\]{}]/g, "")
              : bank.branchAddress,
            accountHolderName: bank.accountHolderName,
            // ? bank.accountHolderName.replace(
            //     /[\\^$*+?;%@'"<>&-|[\]{}]/g,
            //     ''
            // )
            // : bank.accountHolderName
            jointHolderName: bank.jointHolderName
              ? bank.jointHolderName.replace(/[\\^$*+?;%@'"<>&-|[\]{}]/g, "")
              : bank.jointHolderName,
            email: bank.email,
            phoneNumber: bank.phone,
            panNumber: bank.pan,
            customerAddress: bank.address
              ? bank.address.replace(/[\\^$*+?;%@'"<>|[\]{}]/g, "")
              : bank.address,
            accountOpeningDate:
              bank.accountOpeningDate &&
              dayjs(bank.accountOpeningDate).format("YYYY-MM-DD"),
            // TODO: Need to verify keys
            transactionStartDate:
              bank.statementStartsFrom &&
              dayjs(bank.statementStartsFrom).format("YYYY-MM-DD" || null),
            transactionEndDate:
              bank.statementEndsFrom &&
              dayjs(bank.statementEndsFrom).format("YYYY-MM-DD" || null),
            analysisPeriod:
              (bank.analysisPeriod && bank.analysisPeriod) || null,
            fiTypes: ["DEPOSIT"],
            // isNew: bank?.isNew,
          },
          // password: '',
          fileNames: fileNames,
          fileDetails: allUploadedFiles[index].map((file) => ({
            fileName: `${file?.path?.name}`,
            password: file.password || "",
          })),
        };
        // if (type === 3 || type === 4) {
        //     console.log("SANCTION LIMIT:",data);

        //     data.sanctionLimits = bank.sanctionLimit.reduce(
        //         (sanctionLimits, limit) => {
        //             const object = {
        //                 sanctionAmount: limit.amount,
        //                 startDate:
        //                     limit.startDate &&
        //                     dayjs(limit.startDate).format('YYYY-MM-DD'),
        //                 endDate:
        //                     limit.endDate && dayjs(limit.endDate).format('YYYY-MM-DD')
        //             };
        //             sanctionLimits.push(object);
        //             return sanctionLimits;
        //         },
        //         []
        //     );
        // }
        console.log("BANKDETAILS", bankDetails);

        // console.log("BANK DETAILS 2", bankDetails);
        // if(isEdit && bank.isNew === false){
        //     console.log("UNDER IF INDEX OF REDUCE", index);
        //     let test = existingAccEdit[index]
        //     bankDetails.push(test)
        // }
        bankDetails.push(data);
        console.log("PUSH", data);
        return bankDetails;
      }, []);
    }

    let formData = new FormData();
    console.log("NEW FORM DATA", allUploadedFiles, uploadedFiles);

    if (isEdit) {
      uploadedFiles.forEach((item, index) => {
        if (item.length !== 0) {
          if (allUploadedFiles[index].length !== 0) {
            console.log(
              "ISEDIT UPLOADED FILE MAP",
              allUploadedFiles[index][0],
              index
            );
            formData.append(`file`, item[0]);
          }
        }
      });
    } else {
      values.bankAccounts.forEach((formItem, index) => {
        for (let i = 0; i < allUploadedFiles[index].length; i++) {
          if (allUploadedFiles[index][i].length !== 0) {
            console.log("APPENDING FILES",allUploadedFiles[index][i]);

            formData.append(`file`, allUploadedFiles[index][i].path);
          }
        }
      })
    }

    // const newForms = values.bankAccounts?.filter(item => item.isNew === true);
    // console.log('New forms payload:', newForms);

    formData.append(
      "report",
      JSON.stringify({
        ...(isEdit ? {} : { reportName: values.bankAccounts[0].reportName }),
        ...(isEdit ? {} : { reportId: values.bankAccounts[0].referenceId }),
        ...(isEdit ? { reportDetails: { reportId: params.reportId, ...(previousData[0]?.reportName !== values.bankAccounts[0].reportName && { newReportName: values.bankAccounts[0].reportName }) }, ...(bankDetails.length !== 0 && { accountList: bankDetails }), } : { accountList: bankDetails }),
        ...(isEdit ? {} : { gstList: [] }),
        ...(isEdit ? {} : { creditBureauList: [] }),
      })
    );

    console.log("formdata", bankDetails);
    // return;

    try {
      dispatch(setCreateReportLoading(true));
      const createReportResponse = isEdit
        ? await updateReport(formData)
        : await createReport(formData);
      console.log("createReportResponse", createReportResponse);
      dispatch(setCreateReportData(createReportResponse));
      dispatch(setCreateReportLoading(false));

      if (isEdit) {
        if (createReportResponse.report.reportStatus === "ANALYSED") {
          setStartAnalysis(true);
          dispatch(setReportAnalysisProgress(null));
          setReportModalOpen(true);
        }
      } else {
        if (
          createReportResponse.report.reportStatus === "IN PROGRESS" ||
          createReportResponse.report.reportStatus === "INITIALISING"
        ) {
          setStartAnalysis(true);
          setReportModalOpen(true);
        }
      }
    } catch (error) {
      dispatch(setCreateReportError(error));
      dispatch(setCreateReportLoading(false));
      dispatch(showNotification({ message: error.message, type: "error" }));
      dispatch(setReportAnalysisProgress(null));
    }

    console.log(
      "formData",
      formData.entries(),
      values.bankAccounts[0].reportName,
      values.bankAccounts[0].referenceId,
      bankDetails
    );
    for (let pair of formData.entries()) {
      console.log(pair[0], pair[1]);
    }
  };

  // useEffect(() => {
  //     setTimeout(() => {
  //         setReportModalOpen(true);
  //         setStartAnalysis(true);
  //     }, 3000)
  // }, [])

  const getUser = () => {
    let user = sessionStorage.getItem("userDetails");
    if (user) {
      user = JSON.parse(user);
      return user.email;
    }
  };

  // TEST

  useEffect(() => {
    const fetchData = async () => {
      try {
        // If reportId, then call API
        //...API CALL..//

        const formValues = form.getFieldsValue();
        //  console.log("GET FIELD VALUE", formValues);

        const response = await getReportDetailByReferrenceId(params.reportId);

        dispatch(setNavNewReportBtn(false));
        if (location.pathname === "/reports/new-report") {
          dispatch(
            setNavBredcrumb([{ title: "Reports" }, { title: "New Report" }])
          );
        } else if (isEdit) {
          dispatch(
            setNavBredcrumb([
              { title: "Reports" },
              { title: `${response?.report?.reportName}` },
              { title: "Edit" },
            ])
          );
        }
        dispatch(setUploadedAccountDetails(response));

        const commonReportDetails = {
          reportName: response?.report?.reportName,
          referenceId: response?.report?.reportId,
          createdBy: getUser() || "biswarup.mondal@gmail.com",
          createdOn: dayjs(response?.report?.createdOn).format(
            "DD/MM/YYYY hh:mm A"
          ),
        };

        let editUploadedFiles = [];
        response.reportAccounts?.map((item) => {
          editUploadedFiles.push(item.files);
        });

        console.log('editUploadedFiles', editUploadedFiles);

        dispatch(setEditUploadedFiles(editUploadedFiles));

        //Response contains array, and array items represents bank accounts

        const formValuesToPopulate = response?.reportAccounts?.map((item) => {
          console.log("ITEM", item);

          const obj = {
            ...commonReportDetails,
            bankId:
              parseInt(item?.account?.bankId) || formInitialValues?.bankId,
            accountId: item?.account?.accountId || formInitialValues?.accountId,
            bankName: item?.account?.bankName || formInitialValues.bankName,
            accountType:
              item?.account?.accountTypeName || formInitialValues.accountType,
            accountNumber:
              item.account?.accountNumber || formInitialValues.accountNumber,
            analysisFrom: item.account?.analysisFrom
              ? item.account?.analysisFrom === ""
                ? null
                : dayjs(item.account?.analysisFrom)
              : null,
            analysisTo: item.account?.analysisTo
              ? item.account?.analysisTo === ""
                ? null
                : dayjs(item.account?.analysisTo)
              : null,
            statementStartsFrom:
              dayjs(item.account?.startDate) ||
              formInitialValues.statementStartsFrom,
            statementEndsFrom:
              dayjs(item.account?.endDate) ||
              formInitialValues.statementEndsFrom,
            accountOpeningDate: item.account?.accountOpeningDate
              ? item.account?.accountOpeningDate === ""
                ? null
                : dayjs(item.account?.accountOpeningDate)
              : null,
            accountStatus:
              item.account?.accountStatus || formInitialValues.accountStatus,
            ifscCode: item.account?.ifscCode || formInitialValues.ifscCode,
            micrCode: item.account?.micrCode || formInitialValues.micrCode,
            branchName:
              item.account?.branchName || formInitialValues.branchName,
            branchAddress:
              item.account?.branchAddress || formInitialValues.branchAddress,
            accountHolderName:
              item.account?.accountName || formInitialValues.accountHolderName,
            jointHolderName:
              item.account?.jointHolderName ||
              formInitialValues.jointHolderName,
            email: item?.account?.email || formInitialValues.email,
            phone: item?.account?.phoneNumber || formInitialValues.phone,
            pan: item.account?.panNumber || formInitialValues.pan,
            address: item.account?.customerAddress || formInitialValues.address,
            upload: item?.files[0]?.originalName || formInitialValues.upload,
            password: item?.files[0]?.password || formInitialValues.password,
            isNew: item?.account?.isNew || formInitialValues.isNew,
            // sanctionLimit: [formInitialValues.sanctionLimit]
          };

          return obj;
        });

        console.log("ACCOUNT DETAILS >>>>>>>", formValuesToPopulate);

        setPreviousData(formValuesToPopulate);

        const updatedBankAccounts = [...formValues.bankAccounts];
        console.log("updatedBankAccounts", updatedBankAccounts);

        //  updatedBankAccounts[extractedData[0].mapIndex] = formValuesToPopulate;
        console.log("updatedBankAccounts", updatedBankAccounts);

        console.log("UPDATED DATA >>>", updatedBankAccounts);

        form.setFieldsValue({
          bankAccounts: formValuesToPopulate,
        });

        //  console.log("EDIT DATA", response)

        setEditData(response);
      } catch (error) {
        console.log("ERROR", error);
      }
    };

    if (location.pathname.includes("edit")) {
      fetchData();
    }

  }, [location.pathname]);

  const formInitialValues = {
    reportName: "",
    referenceId: "",
    createdBy: getUser() || "biswarup.mondal@gmail.com",
    createdOn: dayjs().format("DD/MM/YYYY hh:mm A"),
    bankName: null,
    bankId: "",
    accountId: null,
    accountType: null,
    accountNumber: "",
    analysisFrom: "",
    analysisTo: "",
    statementStartsFrom: "",
    statementEndsFrom: "",
    accountOpeningDate: "",
    accountStatus: "",
    ifscCode: "",
    micrCode: "",
    branchName: "",
    branchAddress: "",
    accountHolderName: "",
    jointHolderName: "",
    email: "",
    phone: "",
    pan: "",
    address: "",
    upload: [],
    password: "",
    isNew: false,
    // sanctionLimit:[]
  };

  const handleAddNewForm = (add, fields, isNew = false) => {
    console.log("HANDLE ACCOUNT LENGTH", fields.length);

    const isEdit = location.pathname.includes("edit");
    const currentValues = form.getFieldsValue();
    console.log("HANDLE ADD NEW FORM", currentValues);

    const lastFormValues = fields.length
      ? currentValues.bankAccounts[fields.length - 1]
      : {};
    console.log("HANDLE ADD NEW FORM 1", lastFormValues);

    const newFormInitialValues = {
      reportName: lastFormValues.reportName || "",
      referenceId: lastFormValues.referenceId || "",
      createdBy: lastFormValues.createdBy || "",
      createdOn: dayjs().format("DD/MM/YYYY hh:mm A"),
    };
    if (fields.length < 5) {
      add({
        // ...(isEdit ? { isNew: true } : {}),
        ...newFormInitialValues,
      });

      return isNew

    } else {
      // alert("You can only add a maximum of 5 forms.");
      dispatch(
        showNotification({
          message: "You can only add a maximum of 5 forms.",
          type: "error",
        })
      );
    }
  };

  useEffect(() => {
    const currentValues = form.getFieldsValue();
    console.log("currentValues", currentValues);
    if (extractedData && extractedData.length > 0) {
      let updatedBankAccounts = [];
      for (let index = 0; index < extractedData.length; index++) {
        console.log("EXTRACTED DATA", extractedData);
        let populateData = extractedData[index]["0"];
        console.log("populateData", populateData);

        const formValuesToPopulate = {
          reportName:
            currentValues?.bankAccounts[extractedData[0]?.mapIndex]?.reportName ||
            formInitialValues?.reportName,
          referenceId:
            currentValues?.bankAccounts[extractedData[0]?.mapIndex]
              ?.referenceId || formInitialValues?.referenceId,
          createdBy: getUser() || "biswarup.mondal@gmail.com",
          createdOn: dayjs().format("DD/MM/YYYY hh:mm A"),
          bankId: +populateData?.bankId || formInitialValues?.bankId,
          bankName: populateData?.bankName || formInitialValues?.bankName,
          accountType:
            populateData?.accountTypeName || formInitialValues?.accountType,
          accountNumber:
            populateData?.accountNumber || formInitialValues?.accountNumber,
          analysisFrom: populateData?.analysisFrom
            ? populateData?.analysisFrom === ""
              ? null
              : dayjs(populateData?.analysisFrom)
            : null,
          analysisTo: populateData?.analysisTo
            ? populateData?.analysisTo === ""
              ? null
              : dayjs(populateData?.analysisTo)
            : null,
          statementStartsFrom: populateData?.statementStartDate
            ? populateData?.statementStartDate === ""
              ? null
              : dayjs(populateData?.statementStartDate)
            : null,
          statementEndsFrom: populateData?.statementEndDate
            ? populateData?.statementEndDate === ""
              ? null
              : dayjs(populateData?.statementEndDate)
            : null,
          accountOpeningDate: populateData?.accountOpeningDate
            ? populateData?.accountOpeningDate === ""
              ? null
              : dayjs(populateData?.accountOpeningDate)
            : null,
          accountStatus:
            populateData?.accountStatus || formInitialValues?.accountStatus,
          ifscCode: populateData?.ifscCode || formInitialValues?.ifscCode,
          micrCode: populateData?.micrCode || formInitialValues?.micrCode,
          branchName: populateData?.branchName || formInitialValues?.branchName,
          branchAddress:
            populateData?.branchAddress || formInitialValues?.branchAddress,
          accountHolderName:
            populateData?.accountName || formInitialValues?.accountHolderName,
          jointHolderName:
            populateData?.jointHolderName || formInitialValues?.jointHolderName,
          email: populateData?.email || formInitialValues?.email,
          phone: populateData?.phoneNumber || formInitialValues?.phone,
          pan: populateData?.panNumber || formInitialValues?.pan,
          address: populateData?.customerAddress || formInitialValues?.address,
          upload: extractedData[index]?.uploadedFiles.length > 1 ? extractedData[index]?.uploadedFiles.map((file) => file.name) || formInitialValues?.upload : populateData?.fileName || formInitialValues?.upload,
          password: populateData?.password || formInitialValues.password,
          isNew:
            currentValues?.bankAccounts[extractedData[index]?.mapIndex]?.isNew ||
            formInitialValues?.isNew,
        };
        console.log("formValuesToPopulate", formValuesToPopulate);

        const lastFormValues = currentValues[extractedData[index]?.mapIndex];
        console.log("lastFormValues", lastFormValues);
        console.log("mapIndex", extractedData[index]?.mapIndex);

        updatedBankAccounts = [...currentValues?.bankAccounts];
        console.log("updatedBankAccounts", updatedBankAccounts);

        updatedBankAccounts[extractedData[index]?.mapIndex] = formValuesToPopulate;
        console.log("updatedBankAccounts", updatedBankAccounts);

      }
      if (updatedBankAccounts.length > 0) {
        form.setFieldsValue({
          bankAccounts: updatedBankAccounts,
        });
      }

    }
  }, [extractedData, form, dispatch, formInitialValues]);

  const handleOk = () => {
    dispatch(setExtractedData(null))

    // setReportModalOpen(false);
    dispatch(setHomeDetails(null));
    localStorage.setItem('closeBtnClick', true);
    navigate("/reports");
  };

  // const handleCancelBesideAnalyze = () => {
  //   navigate("/reports");
  // };





  const handleCancel = () => {
    setReportModalOpen(false);
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      const isEdit = location.pathname.includes("edit");

      // API CALL WHEN REPORT IS NOT ANALYZED
      const fetchData = async () => {
        try {
          console.log("SET INTERVAL CREATEREPORTDATA", createReportData);
          dispatch(setReportAnalysisProgressLoading(true));
          const response = await getAnalysisProgress(
            createReportData?.report.reportId
          );
          console.log("RESPONSE", response);
          dispatch(setReportAnalysisProgress(response));
          dispatch(setReportAnalysisStatus(response.report.reportStatus));
          // dispatch(setReportAnalysisProgress(reportDto));
          dispatch(setReportAnalysisProgressLoading(false));
          if (response.report.reportStatus === "ANALYSED") {
            clearInterval(intervalId);
          }
          if (isEdit) {
            if (
              response.report.accountStatus === "ANALYSED  - CAM IN PROGRESS"
            ) {
              clearInterval(intervalId);
            }
            return;
          } else {
            if (response.report.reportStatus === "ANALYSED") {
              clearInterval(intervalId);
            }
            return;
          }
        } catch (error) {
          dispatch(setReportAnalysisProgressError(error));
          dispatch(setReportAnalysisProgressLoading(false));
          dispatch(showNotification({ message: error.message, type: "error" }));
          dispatch(setReportAnalysisProgress(null));
          clearInterval(intervalId);
        }
      };

      if (startAnanlysis && createReportData) {
        console.log("TEST IF");

        fetchData();
      } else {
        console.log("TEST ELSE");

        clearInterval(intervalId);
        setReportModalOpen(false);
        setStartAnalysis(false);
      }
    }, 5000);

    return () => clearInterval(intervalId);
  }, [dispatch, startAnanlysis, createReportData]);

  // function toTitleCase(value) {
  //     return value
  //       .toLowerCase()
  //       .split(' ')
  //       .map(word => word.charAt(0).toUpperCase() + word.slice(1))
  //       .join(' ');
  // }

  // console.log('TEST', form.getFieldValue());

  const resetFields = (fields) => {
    console.log("fields", fields);

    if (fields) {
      const formattedFields = fields.map((field) =>
        Array.isArray(field) ? field.join(".") : field
      );
      form.resetFields(formattedFields); // Reset specific fields
    } else {
      form.resetFields(); // Reset the entire form
    }
  };

  // TODO: Need to handle payload for newly added account, everything is going well, but for additonal new account getting only createdBy CreatedOn values on array
  // TODO: I need to get the data from form.getValues because allValues is has giving only small sort of keys

  const onValuesChange = (changedValues, allValues) => {
    let currentValues = form.getFieldsValue();
    let newData = allValues?.bankAccounts;
    // console.log("ON VALUE CHANGE LOG", allValues);
    // console.log("ON VALUE CHANGE LOG 1", previousData);
    // console.log('NEWDATA', newData);
    // console.log('PREVDATA', previousData);

    const modifiedData = [];

    newData.forEach((newItem, index) => {
      const prevItem = previousData[index];
      const modifiedFields = {};

      // Compare each field in newItem with prevItem
      if (prevItem) {
        Object.keys(newItem).forEach((key) => {
          if (newItem[key] !== prevItem[key]) {
            modifiedFields[key] = newItem[key];
          }
        });

        console.log("MODI FIED FIELDS", modifiedFields);

        // If there are modified fields, add this to modifiedData
        if (Object.keys(modifiedFields).length > 0) {
          const modifiedObject = {
            accountId: newItem.accountId,
            ...modifiedFields,
          };
          const fileDetails = [
            {
              fileName: newItem.upload || "", // Set fileName from upload key
              password: newItem.password || "", // Set password from ifscCode key
            },
          ];
          modifiedData.push({
            account: modifiedObject,
            fileDetails: fileDetails,
            password: newItem.password || "",
          });
        }
      } else {
        console.log("NEW ITEM::", newItem);

        const modifiedObject = {
          ...newItem,
        };
        const fileDetails = [
          {
            fileName: newItem.upload || "", // Set fileName from upload key
            password: newItem.password || "", // Set password from ifscCode key
          },
        ];
        modifiedData.push({
          account: modifiedObject,
          fileDetails: fileDetails,
          password: newItem.password || "",
        });
      }
    });

    // let changedAtt = []
    // // // Update the changedFields state with the modified fields
    // // console.log('changedValues =>', changedValues, 'allValues =>', allValues, 'changedFields =>',changedFields,);
    // changedAtt.push(changedValues)
    // setChangedFields((prevChangedFields) => ({
    //   ...prevChangedFields,
    //   ...changedAtt[0].bankAccounts
    // }));
    console.log("changedFields", modifiedData);
  };
  console.log("SET INTERVAL CREATEREPORTDATA", createReportData);
  console.log("SET INTERVAL STARTANALYSIS", startAnanlysis);

  return (
    <div>
      <Form
        form={form}
        layout="vertical"
        onFinish={handleAddBankAccount}
        initialValues={{
          bankAccounts: [formInitialValues],
        }}
        onValuesChange={onValuesChange}
      >
        {location.pathname.includes("edit") && (
          <Row
            justify={"start"}
            align={"bottom"}
            gutter={[24]}
            style={{ padding: "12px", gap: "16px" }}
          >
            <CustomTypography
              style={{
                fontWeight: 500,
                fontSize: "24px",
                lineHeight: "28.8px",
                color: "#000000E0",
              }}
            >
              Edit Report
            </CustomTypography>
            {(editData?.report?.reportStatus === undefined) ? (<Spin indicator={<LoadingOutlined spin />} size="small" />) : (
              <Badge
                count={`${editData?.report?.reportStatus
                  .toLowerCase()
                  .split(" ")
                  .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                  .join(" ")} (${editData?.reportAccounts?.length} ${editData?.reportAccounts?.length > 1 ? "Accounts" : "Account"
                  })`}
                style={{
                  backgroundColor: "#F0F5FF",
                  color: "#10239E",
                  borderRadius: "4px",
                  padding: "0 8px",
                  marginTop: "8px",
                  fontWeight: 500,
                  fontSize: "12px",
                  lineHeight: "20px",
                  border: "none",
                  boxShadow: "none",
                }}
              />)}

          </Row>
        )}
        <Form.List name="bankAccounts">
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, ...restField }, index) => (
                <AddBankAccountFormContainer
                  form={form}
                  isEdit={isEdit}
                  reset={resetFields}
                  mapIndex={index}
                  setCurrentFiles={(files) => handleFilesChange(index, files)}
                  key={key}
                  name={name}
                  remove={remove}
                  {...restField}
                />
              ))}
              <br />
              <div style={{ padding: "12px" }}>
                <Row gutter={[24]}>
                  <CustomButton
                    onClick={() => handleAddNewForm(add, fields)}
                    icon={<PlusOutlined />}
                    size="large"
                    type="dashed"
                    // disabled={true}
                    disabled={fields.length >= 5 ? true : false}
                    style={{ borderRadius: "8px", width: "100%", }}
                  >
                    Add Bank Account
                  </CustomButton>
                </Row>
              </div>
            </>
          )}
        </Form.List>
        <Flex justify="end">
          <div style={{ display: "flex", gap: "8px" }}>
            {/* <CustomButton
              onClick={handleCancelBesideAnalyze}
              btnStyle={{ height: "40px" }}
              size="large"
            >
              Cancel
            </CustomButton> */}
            {/* <>
              <Button type="primary" size="large"
                onClick={showModal} btnStyle={{ height: "40px" }}
              >

                Cancel
              </Button>
              <Modal
                title={<h4 className="custom-modal-title">Are you sure you want to cancel?</h4>}
                open={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                okText="Yes"  // Custom "Yes" text
                cancelText="No"  // Custom "No" text
                titleStyle={{
                  textAlign: 'center', // Center-align the title text
                  padding: '10px 10px', // Padding for the title
                  fontWeight: 'bold', // Bold title
                  fontSize: '18px', // Adjust title font size
                }}

              >
              </Modal>
            </> */}

            <Button
              type="primary"
              size="large"
              onClick={() => {
                const userConfirmed = window.confirm("Are you sure you want to cancel?");
                if (userConfirmed) {
                  handleOk();
                } else {
                  handleCancel();
                }
              }}
              style={{ height: "40px" }}
            >
              Cancel
            </Button>



            <CustomButton
              loading={createReportLoading}
              btnStyle={{ background: "#34C759", height: "40px" }}
              titleStyle={{
                fontWeight: 400,
                fontSize: "16px",
                lineHeight: "24px",
                color: "#FFFFFF",
              }}
              size="large"
              type="primary"
              htmlType="submit"
            >
              Analyze
            </CustomButton>
          </div>
        </Flex>
      </Form>
      <ReportStatusModal
        open={reportModalOpen}
        handleCancel={handleCancel}
        handleOk={handleOk}
      />
      <Spin
        spinning={extractedDataLoading}
        className={styles.fullscreenSpin}
        fullscreen
      />
    </div>
  );
};

const AddBankAccountFormContainer = ({
  name,
  form,
  isEdit,
  reset,
  setCurrentFiles,
  remove,
  mapIndex,
  normFile,
  resetFields,
  ...restField
}) => {
  console.log("REST FIELDS", name, mapIndex, restField);

  return (
    <>
      <div
        style={{
          borderRadius: "6px",
          border: "1px solid #C9EEF2",
          padding: "24px",
          marginTop: "8px",
          background: "#fff",
        }}
      >
        {mapIndex !== 0 && (
          <div style={{ marginLeft: "-8px", paddingBottom: "16px" }}>
            <CustomTypography
              style={{
                fontWeight: 500,
                fontSize: "20px",
                lineHeight: "24px",
                color: "#000000",
              }}
              type={"text"}
            >
              Bank Account{" "}
              {isEdit === false && (<span>
                <DeleteOutlined
                  onClick={() => remove(name)}
                  style={{
                    color: "red",
                    fontSize: "15px",
                    cursor: "pointer",
                  }}
                />
              </span>)}
            </CustomTypography>
          </div>
        )}
        <Row gutter={[24]}>
          <Col lg={6}>
            <div style={{ paddingBottom: "16px" }}>
              <CustomTypography
                style={{
                  fontWeight: 700,
                  fontSize: "16px",
                  lineHeight: "19.6px",
                  color: "#000000",
                }}
                type={"text"}
              >
                Bank Account Details
              </CustomTypography>
            </div>
            <BankAccountDetailFirstForm
              mapIndex={mapIndex}
              name={name}
              {...restField}
            />
          </Col>
          <Divider type="vertical" style={{ height: "auto" }} />
          <Col flex={"auto"} lg={8}>
            <div style={{ paddingBottom: "16px" }}>
              <CustomTypography
                style={{
                  fontWeight: 700,
                  fontSize: "16px",
                  lineHeight: "19.6px",
                  color: "#000000",
                }}
                type={"text"}
              >
                Bank Account Details
              </CustomTypography>
            </div>
            <BankAccountDetailSecondForm
              mapIndex={mapIndex}
              name={name}
              {...restField}
            />
          </Col>
          <Divider type="vertical" style={{ height: "auto" }} />
          <Col lg={9}>
            <div style={{ paddingBottom: "16px" }}>
              <CustomTypography
                style={{
                  fontWeight: 700,
                  fontSize: "16px",
                  lineHeight: "19.6px",
                  color: "#000000",
                }}
                type={"text"}
              >
                Upload Bank Statement
              </CustomTypography>
            </div>
            <UploadBankStatementForm
              form={form}
              isEdit={isEdit}
              resetFields={reset}
              remove={remove}
              mapIndex={mapIndex}
              setCurrentFiles={setCurrentFiles}
              name={name}
              normFile={normFile}
              {...restField}
            />
          </Col>
        </Row>
      </div>
    </>
  );
};

export default NewReport;
